import { useEffect, useRef } from 'react';
import { useLogAnalyticsEvent } from '../../../../../hooks/useLogAnalyticsEvent';
import type { IScreensLogging } from '../../../../../api/types';

type BannerItem = {
  deeplink: string;
  logging: IScreensLogging;
  thumbnail: string;
  thumbnail_ratio: number;
};

/**
 * GoodsCarousel 배너 노출 로깅.
 * - isVisible=true & banner 존재 시 thumbnail 기준으로 1회 발화
 * - 컴포넌트 logging + 배너 item logging 머지 (`RollingBannerList` 컨벤션 동일)
 */
export const useLogDisplayBanner = (
  banner: BannerItem | null,
  componentLogging: IScreensLogging | undefined,
  isVisible: boolean | undefined,
) => {
  const displayedRef = useRef<string | null>(null);

  const logAnalyticsEvent = useLogAnalyticsEvent();

  useEffect(() => {
    if (!banner || !isVisible) return;
    if (displayedRef.current === banner.thumbnail) return;
    displayedRef.current = banner.thumbnail;

    logAnalyticsEvent({
      name: 'VIEW_BANNER',
      analytics: {
        ...componentLogging?.analytics,
        ...banner.logging.analytics,
      },
      ably_only_log: {
        ...componentLogging?.ably_only_log,
        ...banner.logging.ably_only_log,
      },
    });
  }, [banner, isVisible, componentLogging, logAnalyticsEvent]);
};
